import React from 'react';
import { Grid, Box } from '@mui/material';
import TransformationBase from './common/TransformationBase';
import { TransformationHeading } from './common/fields/Heading';
import { COMMON_STYLES, COMMON_VALIDATION } from './common/Constants';
import { SourceColumnField } from './common/fields/SourceColumnField';
import { OutputColumnField } from './common/fields/OutputColumnField';
import { CheckBoxField } from './common/fields/CheckBoxField';
import TransformationArrayField from './common/fields/TransformationArrayField';

const INITIALSTATE = {
  type: 'substr',
  alias: '',
  df: '',
  transformations: [
    {
      sourceColumns: [''],
      outputColumn: '',
      params: { start: 0, length: 1 },
      transformInPlace: false,
    },
  ],
};

const validationSchema = {
  ...COMMON_VALIDATION,
  'transformations.params.start': {
    required: true,
    validate: (value) => {
      if (value === '' || value === null || value === undefined || value < 0) {
        return 'Start position must be a non-negative integer';
      }
      return '';
    },
  },
  'transformations.params.length': {
    required: true,
    validate: (value) => {
      if (value === '' || value === null || value === undefined || value < 0) {
        return 'Length must be a positive integer';
      }
      return '';
    },
  },
};

const renderTransformationFields = ({ formField, errors, setFieldValue, disableForm, headers }) => {
  const handleInPlaceChange = (index, value) => {
    const newTransforms = [...formField.transformations];
    newTransforms[index].transformInPlace = value;
    if (value) {
      newTransforms[index].outputColumn = '';
    }
    setFieldValue('transformations', newTransforms);
  };

  const renderField = ({ transform, index, headers, disableForm, errors }) => {
    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CheckBoxField
              checked={transform.transformInPlace}
              onChange={(value) => handleInPlaceChange(index, value)}
              disabled={disableForm}
            />
          </Grid>

          <Grid item {...COMMON_STYLES.gridItem}>
            <SourceColumnField
              helperText={
                errors?.sourceColumns ||
                (transform.transformInPlace
                  ? 'This column will be modified directly'
                  : 'Select text column to extract from')
              }
              value={transform.sourceColumns?.[0] || ''}
              onChange={(e) => {
                const newTransforms = [...formField.transformations];
                newTransforms[index].sourceColumns = [e.target.value];
                setFieldValue('transformations', newTransforms);
              }}
              headers={headers}
              disabled={disableForm}
              error={!!errors.sourceColumns}
            />
          </Grid>

          <Grid item {...COMMON_STYLES.gridItem}>
            <OutputColumnField
              value={transform.params?.start || 1}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[1-9]\d*$/.test(value) || value === '') {
                  const newTransforms = [...formField.transformations];
                  newTransforms[index].params = {
                    ...newTransforms[index].params,
                    start: value,
                  };
                  setFieldValue('transformations', newTransforms);
                }
              }}
              disabled={disableForm}
              label="Start Position *"
              type="number"
              inputProps={{
                min: 1,
                step: 1,
                inputMode: 'numeric',
                pattern: '[1-9][0-9]*',
              }}
              helperText="Starting index (1-based)"
              error={!!errors.params?.start}
            />
          </Grid>

          <Grid item {...COMMON_STYLES.gridItem}>
            <OutputColumnField
              value={transform.params?.length || 1}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[1-9]\d*$/.test(value) || value === '') {
                  const newTransforms = [...formField.transformations];
                  newTransforms[index].params = {
                    ...newTransforms[index].params,
                    length: value,
                  };
                  setFieldValue('transformations', newTransforms);
                }
              }}
              disabled={disableForm}
              label="Length *"
              type="number"
              inputProps={{
                min: 1,
                step: 1,
                inputMode: 'numeric',
                pattern: '[1-9][0-9]*',
              }}
              helperText="Number of characters to extract"
              error={!!errors.params?.length}
            />
          </Grid>

          {!transform.transformInPlace && (
            <Grid item {...COMMON_STYLES.gridItem}>
              <OutputColumnField
                value={transform.outputColumn}
                onChange={(e) => {
                  const newTransforms = [...formField.transformations];
                  newTransforms[index].outputColumn = e.target.value;
                  setFieldValue('transformations', newTransforms);
                }}
                disabled={disableForm}
                error={!!errors?.outputColumn}
                helperText={errors?.outputColumn || 'Enter output column name'}
              />
            </Grid>
          )}
        </Grid>
      </>
    );
  };

  return (
    <Box sx={COMMON_STYLES.container}>
      <TransformationHeading
        title='Substring - Extract substring ("hello" , start = 2 , length = 3 → "ell")'
        disabled={disableForm}
      />
      <TransformationArrayField
        transformations={formField.transformations}
        setTransformations={(newTransforms) => setFieldValue('transformations', newTransforms)}
        renderField={renderField}
        errors={errors.transformations || []}
        headers={headers}
        disableForm={disableForm}
      />
    </Box>
  );
};

const NodeModal_SubStr = (props) => (
  <TransformationBase
    {...props}
    INITIALSTATE={INITIALSTATE}
    validationSchema={validationSchema}
    renderTransformationFields={renderTransformationFields}
    transformationType={INITIALSTATE.type}
    tranformationName="Substring"
  />
);

export default NodeModal_SubStr;
